/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExportedTOTPCredentialParams } from './ExportedTOTPCredentialParams';
import {
    ExportedTOTPCredentialParamsFromJSON,
    ExportedTOTPCredentialParamsFromJSONTyped,
    ExportedTOTPCredentialParamsToJSON,
    ExportedTOTPCredentialParamsToJSONTyped,
} from './ExportedTOTPCredentialParams';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
    CredentialTypeToJSONTyped,
} from './CredentialType';

/**
 * 
 * @export
 * @interface ExportedTOTPCredential
 */
export interface ExportedTOTPCredential {
    /**
     * The ID of the credential
     * @type {string}
     * @memberof ExportedTOTPCredential
     */
    id: string;
    /**
     * The time when the credential was last used to authenticate successfully
     * @type {Date}
     * @memberof ExportedTOTPCredential
     */
    last_used?: Date;
    /**
     * 
     * @type {CredentialType}
     * @memberof ExportedTOTPCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {ExportedTOTPCredentialParams}
     * @memberof ExportedTOTPCredential
     */
    params: ExportedTOTPCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof ExportedTOTPCredential
     */
    label?: string;
}



/**
 * Check if a given object implements the ExportedTOTPCredential interface.
 */
export function instanceOfExportedTOTPCredential(value: object): value is ExportedTOTPCredential {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}

export function ExportedTOTPCredentialFromJSON(json: any): ExportedTOTPCredential {
    return ExportedTOTPCredentialFromJSONTyped(json, false);
}

export function ExportedTOTPCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedTOTPCredential {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'last_used': json['last_used'] == null ? undefined : (new Date(json['last_used'])),
        'type': CredentialTypeFromJSON(json['type']),
        'params': ExportedTOTPCredentialParamsFromJSON(json['params']),
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function ExportedTOTPCredentialToJSON(json: any): ExportedTOTPCredential {
    return ExportedTOTPCredentialToJSONTyped(json, false);
}

export function ExportedTOTPCredentialToJSONTyped(value?: ExportedTOTPCredential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'last_used': value['last_used'] == null ? value['last_used'] : value['last_used'].toISOString(),
        'type': CredentialTypeToJSON(value['type']),
        'params': ExportedTOTPCredentialParamsToJSON(value['params']),
        'label': value['label'],
    };
}

